import type { EnvType } from '@insify/funnel-components';

const defaultEnv = 'local';
const runtimeConfigEnv = window.insify_runtime_config.ENV;
export const env: EnvType = runtimeConfigEnv === undefined ? defaultEnv : (runtimeConfigEnv as EnvType);

export const isProd = env === 'prod';

export const isProdOrStaging = isProd || env === 'staging';

export const isLocalDev = env === 'local';
